"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function wings(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M14.178 11.4318L11.8942 13.2048L10.959 9.96101L5.54095 8.50977L12.6517 8.87502L14.178 11.4318Z", fill: color, fillOpacity: 0.2 }),
        React.createElement("path", { d: "M6.20251 17.6224L18.4395 8.12512L19.5 10.4846L18.1088 10.0999L18.06 12.5479L6.20251 17.6224Z", fill: color, fillOpacity: 0.5 }),
        React.createElement("path", { d: "M17.097 12.9626L13.5367 6.84181L4.5 6.37756L11.3872 8.22331L13.2547 14.5908L17.097 12.9626Z", fill: color }));
}
exports["default"] = wings;
//# sourceMappingURL=wings.js.map